<script setup lang="ts">

defineProps<{ title: string, href: string }>();
</script>

<template>
  <a :href="href" class="skip">{{ title }}</a>
</template>

<style scoped lang="scss">
.skip {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

.skip:focus {
  position: static;
  width: auto;
  height: auto;
}
</style>
